import React from 'react';
import { connect } from 'react-redux';
import { getTenantState, getAdminState } from '../../store/selectors';
import {
  getTopChosenAcademicOfferings,
  getTopChosenAcademicOfferingsCsv,
  getTopChosenCareers,
  getTopChosenCareersCsv,
} from '../../store/actions';
import NewAndAllTimeUsers from './reporting-components/NewAndAllTimeUsers';
// import SearchAndFilter from './SearchAndFilter';
import PopulationBySchool from './reporting-components/PopulationBySchool';
import HighestLevelOfEducation from './HighestLevelOfEducation';
import EcapCompletions from './EcapCompletions';
import TopChosen from './top-chosen-components/TopChosen';
import NewUserReport from './NewUserReport';

export class Reporting extends React.Component {
  _isMounted = false;

  render() {
    return (
      <>
        <div
          style={this.props.styling.mainContent}
          id="reporting"
          className="reporting"
        >
          <NewAndAllTimeUsers />
          {this.props.tenant.features.includes('highschool') && (
            <PopulationBySchool />
          )}
          {/* <SearchAndFilter /> */}
          {this.props.tenant.features.includes('highschool') && (
            <EcapCompletions />
          )}
          <TopChosen
            section="academicOfferings"
            getTopChosen={this.props.getTopChosenAcademicOfferings}
            getTopChosenCsv={this.props.getTopChosenAcademicOfferingsCsv}
          />
          <TopChosen
            section="careers"
            getTopChosen={this.props.getTopChosenCareers}
            getTopChosenCsv={this.props.getTopChosenCareersCsv}
          />
          <HighestLevelOfEducation />
          <NewUserReport />
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  const admin = getAdminState(state);
  return { tenant, admin };
}

export default connect(mapStateToProps, {
  getTopChosenAcademicOfferings,
  getTopChosenAcademicOfferingsCsv,
  getTopChosenCareers,
  getTopChosenCareersCsv,
})(Reporting);
